import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { execute } from '@/graphql/execute';
import { updateEmailMutation } from '@/mutations/user.mutation';
import { useDialog } from '@/providers/DialogProvider';
import { useFormik } from 'formik';
import { FunctionComponent } from 'react';
import { toast } from 'sonner';

export const ChangeEmailDialog: FunctionComponent<{ userId: string }> = ({ userId }) => {
  const { dismissActiveDialog } = useDialog();

  const formik = useFormik({
    initialValues: {
      newEmail: '',
    },
    onSubmit: async (values) => {
      const t = toast.loading('Changing email...');
      try {
        const result = await execute(updateEmailMutation, { id: userId, email: values.newEmail });
        if (!result.data?.updateEmail) {
          toast.error('Failed to change email', {
            description:
              'We were unable to send a verification email to your new email address, please try again later.',
            id: t,
          });
        } else {
          toast.success('Email verification sent', {
            id: t,
            description: 'Please click the link in the email to verify your new email address',
          });
        }
      } catch (error) {
        toast.error('Failed to change email', { id: t });
      }
      dismissActiveDialog();
    },
  });

  return (
    <div className='space-y-4'>
      <div>
        <h3 className='text-lg font-semibold'>Change Email Address</h3>
        <p className='text-gray-600'>Enter your new email address.</p>
      </div>
      <form onSubmit={formik.handleSubmit} className='space-y-4'>
        <div className='space-y-2'>
          <Label htmlFor='newEmail'>New Email</Label>
          <Input
            id='newEmail'
            name='newEmail'
            type='email'
            value={formik.values.newEmail}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            placeholder='Enter new email address'
          />
        </div>
        <div className='flex justify-end space-x-2'>
          <Button type='button' variant='outline' onClick={dismissActiveDialog}>
            Cancel
          </Button>
          <Button type='submit' disabled={formik.isSubmitting}>
            Change Email
          </Button>
        </div>
      </form>
    </div>
  );
};
